// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "type","client", "location", "locateableType"]

  connect() {
    this.chooseByLocation()
  }

  select(e) {
    if( this.typeTarget.value == "client" ) 
      this.chooseByClient()
    else 
      this.chooseByLocation()
  }

  chooseByClient() {
    this.locationTarget.style.display="none"
    this.locationTarget.querySelector("select").setAttribute("disabled", true)
    this.clientTarget.querySelector("select").removeAttribute("disabled")
    this.clientTarget.style.display="inherit"
    this.locateableTypeTarget.value="Client"
  }

  chooseByLocation() {
    this.clientTarget.style.display="none"
    this.clientTarget.querySelector("select").setAttribute("disabled", true)
    this.locationTarget.querySelector("select").removeAttribute("disabled")
    this.locationTarget.style.display="inherit"
    this.locateableTypeTarget.value="Misc::StockLocation"
  }

}
